import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCatalogTundishes } from "../../../repositories/CatalogTundishRepository";
import { TableTundish } from "../components/TableTundish";
import { useCatalogTundishContext } from "../context/CatalogTundishContext";
type Props = {};

export const CatalogTundishPage = (props: Props) => {
  const { actions } = useCatalogTundishContext();
  const { tundishId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const getCatalogTundishesFromAPI = async () => {
    setIsLoading(true);
    const resp = await getCatalogTundishes();
    if (resp.ok) {
      const tundishes = get(resp, "data.tables[0].rows", []);
      actions.setTundishes(tundishes);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getCatalogTundishesFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Tundishes"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableTundish
              tundishId={tundishId}
              isLoading={isLoading}
              getCatalogTundishesFromAPI={getCatalogTundishesFromAPI}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
